<div class='wrapperLocationStep'>
  <div class='authText'>
    <div>Please let us know your residential address.</div>
  </div>
  <location page='registration' [fields]='fields' [requiredFields]='requiredFields' class='o-mg-t-24' [isFocus]='true'></location>
  <btn text='Continue' [bcg]='authS.bcgApplyBtn' [spinner]='reqPending' (emit)='fillUserInfo()' class='o-mg-t-24'
       [disabled]='!(locationS.locValid$|async)'></btn>
  <btnBack text='Back' (click)='backStepEvent.emit();emit.emit()' class='o-mg-t-24'></btnBack>
</div>